import { render } from "./AllEmergencies.vue?vue&type=template&id=aeae6eb6&scoped=true"
import script from "./AllEmergencies.vue?vue&type=script&lang=js"
export * from "./AllEmergencies.vue?vue&type=script&lang=js"

import "./AllEmergencies.vue?vue&type=style&index=0&id=aeae6eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeae6eb6"]])

export default __exports__